// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'report.page.title.trial_balance': 'Trial Balance',
    'report.page.title.balance_sheet': 'Statement of Position',
    'report.page.title.income_statement': 'Income Statement',
    'report.page.title.cashflow_statement': 'Cashflow Statement',

    'report.label.general_ledger_account_name': 'General Ledger Account',
    'report.label.base_balance_in_cents': 'Balance',
    'report.label.debit': 'Debit',
    'report.label.credit': 'Credit',
    'report.label.account': 'Account',
    'report.label.report_date': 'Report date',
    'report.label.from': 'From',
    'report.label.from_date': 'From Date',
    'report.label.thru_date': 'Thru Date',
    'report.label.as_at': 'As at',
    'report.label.year_ended': 'For Year Ended',
    'report.label.generated_at': 'Generated at ',
    'report.label.assets': 'Assets',
    'report.label.current_assets': 'Current Assets',
    'report.label.total_current_assets': 'Total Current Assets',
    'report.label.non_current_assets': 'Non-current Assets',
    'report.label.total_non_current_assets': 'Total Non-current Assets',
    'report.label.total_assets': 'Total Assets',
    'report.label.liabilities': 'Liabilities',
    'report.label.current_liabilities': 'Current Liabilities',
    'report.label.non_current_liabilities': 'Non-current Liabilities',
    'report.label.total_current_liabilities': 'Total Current Liabilities',
    'report.label.total_non_current_liabilities': 'Total Non-current Liabilities',
    'report.label.total_liabilities': 'Total Liabilities',
    'report.label.equity': 'Equity',
    'report.label.total_equity': 'Total Equity',
    'report.label.total_liabilities_equity': 'Total Liabilities & Equity',
    'report.label.net_income': 'Net Profit',
    'report.label.retained_earnings': 'Retained Earnings',
    'report.label.net_loss': 'Net Loss',
    'report.label.revenue': 'Revenue',
    'report.label.sales': 'Sales',
    'report.label.net_sales': 'Net Sales',
    'report.label.cost_of_sales': 'Cost Of Sales',
    'report.label.total_cost_of_sales': 'Total Cost Of Sales',
    'report.label.operating_income': 'Operating Profit',
    'report.label.other_income': 'Other Income',
    'report.label.other_expenses': 'Other Expenses',
    'report.label.finance_costs': 'Finance Costs',
    'report.label.total_other_income': 'Total Other Income',
    'report.label.total_other_expenses': 'Total Other Expenses',
    'report.label.total_finance_costs': 'Total Finance Costs',
    'report.label.gross_profit': 'Gross Profit',
    'report.label.payroll_expenses': 'Payroll Expenses',
    'report.label.selling_expenses': 'Selling Expenses',
    'report.label.administrative_expenses': 'Administrative Expenses',
    'report.label.total_payroll_expenses': 'Total Payroll Expenses',
    'report.label.total_selling_expenses': 'Total Selling Expenses',
    'report.label.taxes': 'Taxes',
    'report.label.total_taxes': 'Total Taxes',
    'report.label.total_administrative_expenses': 'Total Administrative Expenses',
    'report.label.general_expenses': 'General Expenses',
    'report.label.total_general_expenses': 'Total General Expenses',
    'report.label.finance_and_other_expenses': 'Finance and Other Expenses',
    'report.label.operating_expenses': 'Operating Expenses',
    'report.label.total_operating_expenses': 'Total Operating Expenses',
    'report.label.income_before_taxes': 'Profit Before Taxes',

    'report.label.operating_activities': 'Cash flow from operating activities',
    'report.label.net_operating_activities': 'Cash provided by/(used in) operating activities',
    'report.label.cash_received_from_customers': 'Cash Received from customers',
    'report.label.cash_paid_to_suppliers': 'Cash Paid to suppliers',
    'report.label.cash_paid_for_operating_expenses': 'Cash Paid for operating expenses',
    'report.label.cash_paid_to_employees': 'Cash paid to employees',
    'report.label.interest_expenses': 'Interest expenses',
    'report.label.income_taxes': 'Income taxes',
    'report.label.financing_activities': 'Cash flow from financing activities',
    'report.label.net_financing_activities': 'Cash used in financing activities',
    'report.label.cash_from_repayment_of_borrowing': 'Cash used in repayment of borrowings',
    'report.label.cash_from_issuing_shares': 'Cash received from issuing shares ',
    'report.label.cash_from_loans_received': 'Cash received from proceeds of loans',
    'report.label.cash_from_dividends_paid': 'Cash used in dividends paid',
    'report.label.treasury_shares_purchased': 'Cash used in purchase of treasury shares',
    'report.label.investing_activities': 'Cash flow from investing activities',
    'report.label.net_investing_activities': 'Cash (used in)/provided by investing activities',
    'report.label.cash_from_ppe_purchase': 'Cash used in purchase of plant, property & equipment',
    'report.label.cash_from_ppe_sale': 'Cash received from sale of plant, property & equipment',
    'report.label.cash_from_investment_purchases': 'Cash used in purchase of investments',
    'report.label.cash_from_investment_sales': 'Cash received from sale of investments',
    'report.label.cash_from_loans_made': 'Cash used in loans made to other parties',
    'report.label.cash_from_repayment_of_loans_made': 'Cash received from repayment of loans made to other parties',
    'report.label.net_cash_change': 'Net change in cash during the year',
    'report.label.beginning_cash': 'Cash and cash equivalents at beginning of year',
    'report.label.ending_Cash': 'Cash and cash equivalents at end of year',

    'report.message.no_balances': 'No transactions have been made on an account as yet',
};
